import {
  Button,
  ComponentMultiStyleConfig,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { useCallback } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import { ThemeTypings } from "@chakra-ui/styled-system";

export type ConfirmationModalBaseProps = {
  isOpen: boolean;
  onClose: () => void;

  title: string;
  message?: string;
  confirmButtonLabel: string;
  confirmButtonLabelColorScheme?: ThemeTypings["colorSchemes"];
  cancelButtonLabel: string;
  cancelButtonLabelColorScheme?: ThemeTypings["colorSchemes"];

  /**
   * 確定したときのコールバック。
   */
  onConfirm: () => void;
  /**
   * キャンセルしたときのコールバック。
   */
  onCancel?: () => void;
} & ComponentStyleProps;

export const ConfirmationModalBase = ({
  isOpen,
  onClose,

  title,
  message,
  confirmButtonLabel,
  confirmButtonLabelColorScheme = "teal",
  cancelButtonLabel,
  cancelButtonLabelColorScheme,

  onConfirm,
  onCancel,

  sx,
  ...rest
}: ConfirmationModalBaseProps) => {
  const styles = useMultiStyleConfig("ConfirmationModalBaseStyles");

  const handleCancel = useCallback(() => {
    onClose();
    onCancel?.();
  }, [onCancel, onClose]);
  const handleConfirm = useCallback(() => {
    onClose();
    onConfirm();
  }, [onConfirm, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={{ ...styles.container, ...sx }} {...rest}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{message}</ModalBody>

        <ModalFooter>
          <Button
            colorScheme={confirmButtonLabelColorScheme}
            onClick={handleConfirm}
            sx={styles.confirmButton}
          >
            {confirmButtonLabel}
          </Button>
          <Button
            colorScheme={cancelButtonLabelColorScheme}
            onClick={handleCancel}
            sx={styles.cancelButton}
          >
            {cancelButtonLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const ConfirmationModalBaseStyles: ComponentMultiStyleConfig = {
  parts: ["container", "confirmButton", "cancelButton"],
  baseStyle: {
    container: {},
    confirmButton: {},
    cancelButton: {
      ml: "2",
    },
  },
};
